(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    function unmuteAutoplays() {
      document.querySelectorAll('deferred-media[autoplay] video').forEach(video => {
        video.removeAttribute('muted');
        video.muted = false;
      });
    }

    unmuteAutoplays();

    const observer = new MutationObserver(unmuteAutoplays);
    observer.observe(document.body, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

})();
